import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import deleteContainer from '../../../../actions/deleteContainer';
import DeleteRoom from './DeleteRoom';

const mapStateToProps = ({ estimateBuilder }) => ({
  designId: estimateBuilder.uiState.selectedEstimate,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ deleteRoom: deleteContainer }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRoom);
